<template>
  <v-card class="weather-detail" tile>
    <v-row no-gutters align="center" justify="end" class="tool-bar">
      <v-col cols="auto">
        <v-btn x-small icon color="#5f5f5f" @click="close()">
          <v-icon x-small>
            mdi-close
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      v-if="tableData"
      :headers="headers"
      :items="tableData"
      :items-per-page="-1"
      :hide-default-footer="true"
      dense
      height="800px"
      fixed-header
      class="weather-table"
      disable-sort
    >
      <template v-slot:header="{ items, headers }">
        <thead>
          <tr>
            <th
              v-for="category in categories"
              :key="category.text"
              :colspan="category.colspan ? category.colspan : 1"
              :class="category.class"
            >
              {{ category.text }}
            </th>
          </tr>
          <tr>
            <th v-for="header in headers" :key="header.text">
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>
      <template v-slot:item.weather="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-img
                :src="
                  require(`@/assets/images/weather-icons/nhk/${item.weather}.png`)
                "
                width="20px"
                contain
                class="mx-auto"
              ></v-img>
            </div>
          </template>
          <span>{{ getTooltip(item, "weather") }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.weatherNhk="{ item }">
        <v-tooltip v-if="item.weatherNhk" bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-img
                :src="
                  require(`@/assets/images/weather-icons/nhk/${item.weatherNhk}.png`)
                "
                width="20px"
                contain
                class="mx-auto"
              ></v-img>
            </div>
          </template>
          <span>{{ item.weatherNhk }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.weatherTen="{ item }">
        <v-tooltip v-if="item.weatherTen" bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-img
                :src="
                  require(`@/assets/images/weather-icons/ten/${item.weatherTen}.png`)
                "
                width="30px"
                contain
                class="mx-auto"
              ></v-img>
            </div>
          </template>
          <span>{{ item.weatherTen }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.weatherWni="{ item }">
        <v-tooltip v-if="item.weatherWni" bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-img
                :src="
                  require(`@/assets/images/weather-icons/wni/${item.weatherWni}.png`)
                "
                width="30px"
                contain
                class="mx-auto"
              ></v-img>
            </div>
          </template>
          <span>{{ item.weatherWni }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.rain="{ item }">
        <div style="font-weight: bold">
          <span :style="{ color: item.rainColor }">{{ item.rain }}</span>
        </div>
      </template>
      <template v-slot:item.rainNhk="{ item }">
        <div style="font-weight: bold">
          <span :style="{ color: item.rainColorNhk }">{{ item.rainNhk }}</span>
        </div>
      </template>
      <template v-slot:item.rainTen="{ item }">
        <div style="font-weight: bold">
          <span :style="{ color: item.rainColorTen }">{{ item.rainTen }}</span>
        </div>
      </template>
      <template v-slot:item.rainWni="{ item }">
        <div style="font-weight: bold">
          <span :style="{ color: item.rainColorWni }">{{ item.rainWni }}</span>
        </div>
      </template>
      <template v-slot:item.windDirection="{ item }">
        <div v-if="item.windDirection">
          <v-icon
            small
            class="outlined"
            :color="getWindColor(item.windSpeed)"
            :style="
              `transform: rotate(${(360 / 16) * item.windDirection - 180}deg)`
            "
          >
            mdi-navigation
          </v-icon>
        </div>
      </template>
      <template v-slot:item.windDirectionNhk="{ item }">
        <div v-if="item.windDirectionNhk">
          <v-icon
            small
            class="outlined"
            :color="getWindColor(item.windSpeedNhk)"
            :style="
              `transform: rotate(${(360 / 16) * item.windDirectionNhk -
                180}deg)`
            "
          >
            mdi-navigation
          </v-icon>
        </div>
      </template>
      <template v-slot:item.windDirectionTen="{ item }">
        <div v-if="item.windDirectionTen">
          <v-icon
            small
            class="outlined"
            :color="getWindColor(item.windSpeedTen)"
            :style="
              `transform: rotate(${(360 / 16) * item.windDirectionTen -
                180}deg)`
            "
          >
            mdi-navigation
          </v-icon>
        </div>
      </template>
      <template v-slot:item.windDirectionWni="{ item }">
        <div v-if="item.windDirectionWni">
          <v-icon
            small
            class="outlined"
            :color="getWindColor(item.windSpeedWni)"
            :style="
              `transform: rotate(${(360 / 16) * item.windDirectionWni -
                180}deg)`
            "
          >
            mdi-navigation
          </v-icon>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  name: "WeatherDetail",
  props: ["tableData", "weatherDate"],
  data() {
    return {
      categories: [
        {
          text: "",
          align: "start",
          sortable: false,
          value: "time",
          class: "category"
        },
        {
          text: "統合",
          colspan: 5,
          class: "category"
        },
        {
          text: `NHK (${this.weatherDate.nhkDate})`,
          colspan: 5,
          class: "category"
        },
        {
          text: `Tenkijp (${this.weatherDate.tenDate})`,
          colspan: 5,
          class: "category"
        },
        {
          text: `WNI (${this.weatherDate.wniDate})`,
          colspan: 5,
          class: "category"
        }
      ],
      headers: [
        {
          text: "時刻",
          align: "start",
          value: "time",
          width: "120px",
          class: "divider-right",
          cellClass: "divider-right"
        },
        { text: "天気", value: "weather", align: "center" },
        { text: "気温\n(℃)", value: "temperatures", align: "center" },
        { text: "降雨量\n(mm/h)", value: "rain", align: "right" },
        { text: "風向", value: "windDirection", align: "center" },
        {
          text: "風速\n(m/s)",
          value: "windSpeed",
          align: "right",
          class: "divider-right",
          cellClass: "divider-right"
        },
        { text: "天気", value: "weatherNhk", align: "center" },
        { text: "気温\n(℃)", value: "temperaturesNhk", align: "center" },
        { text: "降雨量\n(mm/h)", value: "rainNhk", align: "right" },
        { text: "風向", value: "windDirectionNhk", align: "center" },
        {
          text: "風速\n(m/s)",
          value: "windSpeedNhk",
          align: "right",
          class: "divider-right",
          cellClass: "divider-right"
        },
        { text: "天気", value: "weatherTen", align: "center" },
        { text: "気温\n(℃)", value: "temperaturesTen", align: "center" },
        { text: "降雨量\n(mm/h)", value: "rainTen", align: "right" },
        { text: "風向", value: "windDirectionTen", align: "center" },
        {
          text: "風速\n(m/s)",
          value: "windSpeedTen",
          align: "right",
          class: "divider-right",
          cellClass: "divider-right"
        },
        { text: "天気", value: "weatherWni", align: "center" },
        { text: "気温\n(℃)", value: "temperaturesWni", align: "center" },
        { text: "降雨量\n(mm/h)", value: "rainWni", align: "right" },
        { text: "風向", value: "windDirectionWni", align: "center" },
        { text: "風速\n(m/s)", value: "windSpeedWni", align: "right" }
      ]
    };
  },
  methods: {
    getTooltip(o, key) {
      return `NHK: ${o[key + "Nhk"]}, Tenkijp: ${o[key + "Ten"]}, WNI: ${
        o[key + "Wni"]
      }`;
    },
    close() {
      this.$emit("close");
    },
    getWindColor(speed) {
      const value = speed;
      const colors = [
        { color: "#b40068", value: 25 },
        { color: "#f12705", value: 20 },
        { color: "#f49904", value: 15 },
        { color: "#f9f503", value: 10 },
        { color: "#3e42ff", value: 5 },
        { color: "#b9ebfa", value: 0 }
      ];

      let current;
      for (const color of colors) {
        if (color.value <= value) {
          current = color.color;
          break;
        }
      }
      return current;
    }
  }
};
</script>

<style>
.weather-detail {
  .tool-bar-title {
    font-size: 12px;
    font-weight: bold;
    color: #5f5f5f;
    margin: 0 10px;
  }
  .tool-bar {
    background-color: #eeeeee;
    width: inherit;
  }
  .weather-table {
    overflow: scroll;
  }
  .weather-table th,
  .weather-table td {
    padding: 0 10px !important;
    font-size: 12px !important;
  }
  .weather-table th.category {
    background-color: white !important;
    color: #5f5f5f !important;
    text-align: center !important;
    border-right: thin solid rgba(0, 0, 0, 0.12);
  }
  .weather-table .divider-right {
    border-right: thin solid rgba(0, 0, 0, 0.12);
  }
}
.v-application .weather-detail .weather-table th {
  background-color: #5560a1 !important;
  color: white !important;
  white-space: pre-line;
  text-align: center !important;
}
</style>
